import React from 'react'
import { ClientMailsWrapper } from './styles'
import Mail from 'globals/models/Mail'
import DataTableAgenda from './components/DataTableAgenda'
import DataTableAgendaDestroyings from './components/DataTableAgendaDestroyings'
import DataTableClient from './components/DataTableClient'
import DataTableClientHistory from './components/DataTableClientHistory'

interface IProps {
  data: Mail[],
  selectedMailsIds: React.Key[],
  setSelectedMailsIds: (selectedMailsIds: React.Key[]) => void,
  onMailClicked: (mail: Mail) => void,
  hideHeader?: boolean,
  currentPage?: number,
  pageSize?: number,
  showPackages?: boolean,
  alwaysHideCheckboxes?: boolean,
  alwaysShowCheckboxes?: boolean,
  showAddTrackingNumber?: boolean,
  disable?: boolean,
  quickAction?: string,
  quickActionCallback?: any,
  lineStyle?: string
}

const ClientMails = (props: IProps) => {
  let DataTableComponent: any = () => <></>
  switch (props.lineStyle) {
    case 'agenda': DataTableComponent = DataTableAgenda; break
    case 'agendaDestroyings': DataTableComponent = DataTableAgendaDestroyings; break
    case 'client': DataTableComponent = DataTableClient; break
    case 'clientHistory': DataTableComponent = DataTableClientHistory; break
  }

  return (
    <ClientMailsWrapper>
      <DataTableComponent {...props} />
    </ClientMailsWrapper>
  )
}

export default ClientMails
